function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "100",
  height: "100",
  viewBox: "0 0 100 100",
  focusable: "false"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "New_Gradient_Swatch_5",
  x1: "11.68",
  y1: "11.68",
  x2: "88.99",
  y2: "88.99",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#35abab"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".67",
  stopColor: "#676e96"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".89",
  stopColor: "#5c568f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#56488b"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M50 0a50 50 0 1050 50A50 50 0 0050 0zm28.87 36l-41 41-.42.43L17.6 57.64a2 2 0 010-2.83L20.43 52a2 2 0 012.82 0l14.18 14.16 35.79-35.78a2 2 0 012.83 0l2.82 2.82a2 2 0 010 2.8z",
  fill: "url(#New_Gradient_Swatch_5)"
})));